























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalRegrasAgendaGarantiaMinima extends Vue {
  $refs!: { formRegra: any }
  loadingCloseButton = false
  descartes: { codigo: string; descricao: string }[] = []
  step = 1
  formValido = false
  showModalConfirmacao = false
  indiceDescarteParaRemover: number | null = null
  showModalProcedimento = false

  novoProcedimento = {
    codigo: '',
    descricao: ''
  }

  get novaRegra() {
    return this.getRegrasDeCalculoStore.novaRegra
  }

  set novaRegra(value: any) {
    this.getRegrasDeCalculoStore.setNovaRegra(value)
  }

  headersDescarte = [
    { text: 'Código', value: 'codigo', sortable: false },
    { text: 'Descrição', value: 'descricao', sortable: false },
    { text: 'Ações', value: 'actions', sortable: false }
  ]

  get estabelecimentos() {
    return this.getRegrasDeCalculoStore.fontesPagadoras
  }

  get profissionais() {
    return this.getRegrasDeCalculoStore.gestores
  }

  get showModal() { return this.getRegrasDeCalculoStore.modal.regraAgendaGarantiaMinima }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraAgendaGarantiaMinima', value }) }

  rules = {
    obrigatorio: (v: any) => !!v || 'Campo obrigatório'
  }

  irParaStep2() {
    const form = this.$refs.formRegra
    if (form.validate()) {
      this.step = 2
    }
  }

  async salvar() {
    try {
      this.getRegrasDeCalculoStore.setNovaRegra(this.novaRegra)
      const response = await this.getRegrasDeCalculoStore.salvarRegra()
      if (!response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `${response.message || 'Ocorreu um erro ao salvar!'} ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828'
        })
        return
      }
      for (const descarte of this.descartes) {
        this.getRegrasDeCalculoStore.setDescarte(descarte)
        await this.getRegrasDeCalculoStore.salvarDescarte()
      }

      this.closeModal()
    } catch (err) {
      console.error('Erro ao salvar regra ou descartes', err)
    }
  }

  abrirModalProcedimento() {
    this.novoProcedimento = { codigo: '', descricao: '' }
    this.showModalProcedimento = true
  }

  fecharModalProcedimento() {
    this.showModalProcedimento = false
  }


  get descartesFiltrados() {
    if (this.mode === 'EDIT') {
      return [...this.getRegrasDeCalculoStore.descarteProcedimentos, ...this.descartes]
    }
    return this.descartes
  }

  confirmarProcedimento() {
    if (!this.novoProcedimento.codigo || !this.novoProcedimento.descricao) return

    const novo = { ...this.novoProcedimento }

    this.descartes.push(novo)

    this.fecharModalProcedimento()
  }

  abrirModalConfirmacao(item: any, index: number) {
    this.indiceDescarteParaRemover = index
    if (item) {
      this.getRegrasDeCalculoStore.setIdForDeleteItem(item.id)
    }
    this.showModalConfirmacao = true
  }

  fecharModalConfirmacao() {
    this.showModalConfirmacao = false
    this.indiceDescarteParaRemover = null
  }

  async confirmarRemocaoDescarte() {
    if (this.getRegrasDeCalculoStore.idForDeleteItem) {
      await this.getRegrasDeCalculoStore.deleteDescarte()
      await this.getRegrasDeCalculoStore.getDescartesProcedimentosByRegraAgendaGarantiaMinima({
        regraId: this.novaRegra.id,
        pagination: this.getRegrasDeCalculoStore.paginacaoRegraAgendaGarantiaMinima
      })
      this.fecharModalConfirmacao()
      return
    }
    if (this.indiceDescarteParaRemover !== null) {
      this.descartes.splice(this.indiceDescarteParaRemover, 1)
      this.fecharModalConfirmacao()
    }
  }

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get mode() { return this.getRegrasDeCalculoStore.modeModalAgendaGarantiaMinima }

  async closeModal() {
    this.loadingCloseButton = true
    await this.getRegrasDeCalculoStore.getRegraAgendaGarantiaMinima(this.getRegrasDeCalculoStore.paginacaoRegraAgendaGarantiaMinima)
    this.showModal = false
    this.resetarCampos()
    this.loadingCloseButton = false
  }

  resetarCampos() {
    this.novaRegra = {
      nome: '',
      estabelecimentoId: null,
      profissionalId: '',
      ativo: true
    }

    this.descartes = []

    this.novoProcedimento = { codigo: '', descricao: '' }
    this.formValido = false
    this.step = 1
  }

  @Watch('showModal')
  async onShowModalFinanceiroRegraDeCalculo(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setMode('CREATE')
      this.step = 1
    }
  }
}
